// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page.BC-Page__GlobalSelling .card-subs {
  margin-top: 20px;
  padding: 20px;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container {
  display: flex;
  justify-content: space-between;
  gap: 6rem;
  align-items: center;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item__label {
  font-weight: 500;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item__content {
  color: #6d7175;
}

.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-action {
  min-width: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global-selling.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".BC-Page.BC-Page__GlobalSelling .card-subs {\n  margin-top: 20px;\n  padding: 20px;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container {\n  display: flex;\n  justify-content: space-between;\n  gap: 6rem;\n  align-items: center;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item__label {\n  font-weight: 500;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-item__content {\n  color: #6d7175;\n}\n\n.BC-Page.BC-Page__GlobalSelling .card-subs-container .card-subs-action {\n  min-width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
